export default {

  // SOIL
  select(params) {
    return env.API.post('test/soil/select', params);
  },
  delete(id) {
    return env.API.delete('test/soil/' + id);
  },
  get(id) {
    return env.API.get('test/soil/' + id);
  },
  update(id, data) {
    return env.API.put('test/soil/' + id, data);
  },
  create(data) {
    return env.API.post('test/soil', data);
  },
  downloadReport(id) {
    return env.API.get('test/soil/' + id + '/report');
  },
}
